var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"login__containerLogin text-center widthControl"},[_c('ProfilePhoneVerification',{attrs:{"userProfile":_vm.userProfile,"showVerification":true,"isSignup":true}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }